import { isFieldType, isFormFieldType } from '@core-engine/schema/constants.js'
import type { FormField, SchemaField } from '@core-engine/schema/types.js'
import { isRecord } from '@core-engine/utils/record.js'

export function assertSupportedSchemaFieldTree(field: SchemaField): void {
  assertSupportedSchemaFieldType(field)
  if (field.fields) {
    for (const nestedField of field.fields) {
      assertSupportedSchemaFieldTree(nestedField)
    }
  }
  if (field.items) {
    assertSupportedSchemaFieldTree(field.items as SchemaField)
  }
  if (field.tabs) {
    for (const tab of field.tabs) {
      for (const nestedField of tab.fields || []) {
        assertSupportedSchemaFieldTree(nestedField)
      }
      for (const nestedField of getTabSlotFields(tab.slot)) {
        assertSupportedSchemaFieldTree(nestedField)
      }
    }
  }
}

export function assertSupportedSchemaFieldType(field: SchemaField): void {
  if (typeof field.type === 'string' && isFieldType(field.type)) return
  throw new Error(
    `Field "${field.name || 'unnamed'}" has unsupported type "${String(field.type)}".`
  )
}

export function assertSupportedFormFieldTree(field: FormField): void {
  assertSupportedFormFieldType(field)
  if (field.fields) {
    for (const nestedField of field.fields) {
      assertSupportedFormFieldTree(nestedField)
    }
  }
}

export function assertSupportedFormFieldType(field: FormField): void {
  if (typeof field.type === 'string' && isFormFieldType(field.type)) return
  throw new Error(
    `Form field "${field.name || 'unnamed'}" has unsupported type "${String(field.type)}".`
  )
}

function getTabSlotFields(slot: unknown): SchemaField[] {
  if (!isRecord(slot)) return []
  const fields: SchemaField[] = []
  for (const area of [slot.main, slot.sidebar]) {
    if (isRecord(area) && Array.isArray(area.fields)) {
      fields.push(...(area.fields as SchemaField[]))
    }
  }
  return fields
}
